import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../helper/BaseUrl";
import Slider from "react-slick";
import Icons from "../../myIcon/Icons";
import { Accordion, Card } from "react-bootstrap";
import HaldiLogoslider from "../Haldi/HaldiLogoslider";
import HaldiBook from "../Haldi/HaldiBook";

export default function DynamicPages({ initialData }) {
  const sliderRef = useRef(null);
  const navigate = useNavigate();
  const { dynamicslug } = useParams();

  const [activeKey, setActiveKey] = useState("0");
  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const [data, setData] = useState(initialData || []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BaseUrl}/api/${dynamicslug}`);
        setData(response.data?.data);
        if(response.error){
            navigate("/404")
        }
      } catch (error) {
        navigate("/404")
        console.error("Dynamic page error:", error);
      }
    };

    fetchData();
  }, [dynamicslug]);

  if (!data) return null;

  const serviceSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 3,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: false,
    cssEase: "ease",
    draggable: false,
    swipe: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          draggable: true,
          swipe: true,
          autoplay: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          draggable: true,
          swipe: true,
          autoplay: true,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 1,
          draggable: true,
          swipe: true,
          autoplay: true,
        },
      },
    ],
  };

  const CustomArrows = () => (
    <>
      <div
        className="default-arrowleft"
        onClick={() => sliderRef.current.slickPrev()}
      >
        <Icons name="arrowLeft" />
      </div>
      <div
        className="default-arrowright"
        onClick={() => sliderRef.current.slickNext()}
      >
        <Icons name="arrowRight" />
      </div>
    </>
  );
  const gallerySettings = {
    dots: false,
    arrows: false,
    slidesToShow: 4,
    infinite: true,
    autoplay: true,
    slidesToScroll: 1,
    pauseOnHover: false,
    cssEase: "linear",
    autoplaySpeed: 0,
    speed: 5000,
    remove: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 2560,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const threeImage = [data?.image1, data?.image2, data?.image3].filter(Boolean);
  const additional_images = Array.isArray(data?.additional_images)
    ? data.additional_images
    : [];

  return (
    <>
      <div className="subheader pagebanner">
        <div className="subheader-text">
          <span>{data?.title}</span>
          <p className="subheader-head">{data?.title}</p>

          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li> | </li>
            <li>{data?.title}</li>
          </ul>
        </div>

        {data?.banner_image && (
          <img
            src={`${data?.banner_image}`}
            className="img-responsive"
            alt={data?.title}
          />
        )}
      </div>

      <section className="haldipage-head">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-10">
              <span>{data?.quote_subtitle}</span>
              <h1>{data?.quote_title}</h1>
              <p
                className="wow animate__animated animate__fadeInUp"
                data-wow-duration="1s"
                data-wow-delay="0.2s"
              >
                {data?.quote_description}
              </p>
              <Link to="/contact-us#contact-form" className="default-btn red-default">
                learn more
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className="haldipage-image">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="p-relative">
                <Slider {...serviceSettings} ref={sliderRef}>
                  {threeImage.map((img, ind) => (
                    <div className="haldi-slide" key={ind}>
                      <img
                        src={`${img}`}
                        alt={`Haldi image ${ind + 1}`}
                        className="img-responsive"
                        loading="lazy"
                      />
                    </div>
                  ))}
                </Slider>

                <CustomArrows />
              </div>
            </div>
          </div>
        </div>
      </section>
      <HaldiLogoslider />

      <section className="haldipage-service">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="haldiservice-head">
                <span className="gradient-color">{data?.service_subtitle}</span>
                <h2 className="heading">{data?.service_title}</h2>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 order-2 order-md-1 order-lg-1">
              <img
                src={data?.service_image}
                className="img-responsive"
                alt="service"
                loading="lazy"
              />
            </div>

            <div className="col-lg-6 col-md-6 order-1 order-md-2 order-lg-2">
              <Accordion activeKey={activeKey} className="service-accord">
                {data?.service_description?.map((item, index) => (
                  <Card
                    key={index}
                    className={activeKey === String(index) ? "active" : ""}
                  >
                    <Card.Header>
                      <Accordion.Item eventKey={String(index)}>
                        <Accordion.Header
                          as="span"
                          onClick={() => handleToggle(String(index))}
                        >
                          {item.question}
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>{item.answer}</p>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Card.Header>
                  </Card>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </section>

      <HaldiBook />
      {additional_images.length > 0 && (
        <section className="haldipage-gallery">
          <Slider {...gallerySettings}>
            {additional_images.map((img, i) => (
              <div key={i} className="haldi-gallery-slide">
                <img
                  src={img}
                  alt={`Haldi image ${i + 1}`}
                  className="img-responsive"
                  loading="lazy"
                />
              </div>
            ))}
          </Slider>
        </section>
      )}

      <section className="haldipage-craft">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-10">
              <h4 className="heading">{data?.second_title}</h4>
              <p
                className="wow animate__animated animate__fadeInUp"
                data-wow-duration="1s"
                data-wow-delay="0.2s"
                dangerouslySetInnerHTML={{
                  __html: data?.second_description,
                }}
              ></p>
            </div>
          </div>
        </div>
      </section>
      <section className="faq-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className="faq-side-content">
                <h2 className="heading">FAQs</h2>
                <p>
                  Everything you need to know about our Mehandi collection,
                  personalisation options, ordering process, and delivery
                  timelines made simple and seamless.
                </p>
                <Link to="/contact-us#contact-form" className="default-btn red-default">
                  talk to an expert
                </Link>
              </div>
            </div>

            <div className="col-lg-8 col-md-8">
              <Accordion activeKey={activeKey} className="service-accord">
                {data?.faq?.map((item, index) => (
                  <Card
                    key={index}
                    className={activeKey === String(index) ? "active" : ""}
                  >
                    <Card.Header>
                      <Accordion.Item eventKey={String(index)}>
                        <Accordion.Header
                          as="span"
                          onClick={() => handleToggle(String(index))}
                        >
                          {item.question}
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>{item.answer}</p>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Card.Header>
                  </Card>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </section>

      {/* 

      <section className="haldipage-craft">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-10">
              <h4 className="heading">{haldiCraft?.heading}</h4>
              <p
                className="wow animate__animated animate__fadeInUp"
                data-wow-duration="1s"
                data-wow-delay="0.2s"
              >
                {haldiCraft?.description}
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="faq-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className="faq-side-content">
                <h2 className="heading">{dynamicFaq?.heading}</h2>
                <p>{dynamicFaq?.description}</p>
                <Link to={dynamicFaq?.link} className="default-btn red-default">
                  {dynamicFaq?.buttonText}
                </Link>
              </div>
            </div>

            <div className="col-lg-8 col-md-8">
              <Accordion activeKey={activeKey} className="service-accord">
                {dynamicFaq?.accordions?.map((item, index) => (
                  <Card
                    key={index}
                    className={activeKey === String(index) ? "active" : ""}
                  >
                    <Card.Header>
                      <Accordion.Item eventKey={String(index)}>
                        <Accordion.Header
                          as="span"
                          onClick={() => handleToggle(String(index))}
                        >
                          {item.title}
                        </Accordion.Header>
                        <Accordion.Body>
                          <p>{item.description}</p>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Card.Header>
                  </Card>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
}
